import { SystemRole, ClientRole } from '../types/index.js';
export const SYSTEM_ROLE_LABELS = {
    [SystemRole.ADMIN]: 'Administrator',
    [SystemRole.PLANNER]: 'Event Planner',
    [SystemRole.CLIENT]: 'Client',
    [SystemRole.VENDOR]: 'Vendor',
};
export const CLIENT_ROLE_LABELS = {
    [ClientRole.BRIDE]: 'Bride',
    [ClientRole.GROOM]: 'Groom',
    [ClientRole.PARENT_OF_BRIDE]: 'Parent of the Bride',
    [ClientRole.PARENT_OF_GROOM]: 'Parent of the Groom',
    [ClientRole.OTHER_FAMILY]: 'Other Family Member',
    [ClientRole.BAR_BAT_MITZVAH]: 'Bar/Bat Mitzvah',
    [ClientRole.HOST]: 'Host',
    [ClientRole.OTHER]: 'Other',
};
export const CLIENT_ROLE_LABELS_HE = {
    [ClientRole.BRIDE]: 'כלה',
    [ClientRole.GROOM]: 'חתן',
    [ClientRole.PARENT_OF_BRIDE]: 'הורה של הכלה',
    [ClientRole.PARENT_OF_GROOM]: 'הורה של החתן',
    [ClientRole.OTHER_FAMILY]: 'בן משפחה',
    [ClientRole.BAR_BAT_MITZVAH]: 'בר/בת מצווה',
    [ClientRole.HOST]: 'מארח',
    [ClientRole.OTHER]: 'אחר',
};
//# sourceMappingURL=roles.js.map